// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// const languages = ["English", "Hindi", "Telugu"];

// const AuthNavbar = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [langOpen, setLangOpen] = useState(false);
//   const [selectedLang, setSelectedLang] = useState("English");

//   const isSignIn = location.pathname === "/sign-in";
//   const isRegister = location.pathname === "/register";

//   const handleAuthAction = () => {
//     if (isSignIn) {
//       navigate("/register");
//     } else {
//       navigate("/sign-in");
//     }
//   };

//   const handleLangSelect = (lang) => {
//     setSelectedLang(lang);
//     setLangOpen(false);
//   };

//   return (
//     <nav className="bg-white w-full sticky top-0 z-50 border-b">
//       <div className=" flex items-center justify-between h-14 px-4 md:px-6">
//           {/* LEFT → LOGO */}
//           <div className="flex items-center">
//             <a href="/" className="flex items-center">
//               <img
//                 src="/Home/FemCareLogo.svg"
//                 alt="Logo"
//               className="h-8 md:h-10 w-auto"
//               />
//             </a>
//           </div>

//           {/* RIGHT SIDE */}
//           <div className="flex items-center gap-3 md:gap-5">
//             {/* TEXT + CTA */}
//             <div className="hidden sm:flex items-center gap-3">
//               {isRegister && (
//                 <span className="ava-text-sm whitespace-nowrap">
//                   Already have an account?
//                 </span>
//               )}
//               {isSignIn && (
//                 <span className="ava-text-sm whitespace-nowrap">
//                   Don't have an account?
//                 </span>
//               )}
//             </div>

//             {/* CTA BUTTON */}
//             <button
//               onClick={handleAuthAction}
//               className="px-3 md:px-4 py-1.5 ava-text-xs md:text-sm rounded-md border-2 transition-all hover:bg-gray-50"
//               style={{
//                 color: "var(--primary-color)",
//                 borderColor: "var(--primary-color)",
//               }}
//             >
//               {isSignIn ? "Sign up" : "Sign in"}
//             </button>

//             {/* DIVIDER */}
//             <div className="hidden sm:block w-px h-5 bg-gray-200" />

//             {/* LANGUAGE */}
//             <div className="relative">
//               <button
//                 onClick={() => setLangOpen((prev) => !prev)}
//                 className="flex items-center gap-1 ava-text-sm text-gray-700 hover:text-gray-900 px-2 py-1 rounded-md hover:bg-gray-50"
//               >
//                 🌐
//                 <span className="hidden md:inline">{selectedLang}</span>

//                 <svg
//                   className="w-3 h-3 transition-transform"
//                   style={{
//                     transform: langOpen ? "rotate(180deg)" : "rotate(0deg)",
//                   }}
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   viewBox="0 0 24 24"
//                 >
//                   <path d="M19 9l-7 7-7-7" />
//                 </svg>
//               </button>

//               {langOpen && (
//                 <>
//                   <div
//                     className="fixed inset-0 z-40"
//                     onClick={() => setLangOpen(false)}
//                   />
//                   <div className="absolute right-0 mt-2 w-36 bg-white border rounded-lg shadow-lg z-50">
//                     {languages.map((lang) => (
//                       <button
//                         key={lang}
//                         onClick={() => handleLangSelect(lang)}
//                         className="w-full text-left px-4 py-2 ava-text-sm hover:bg-gray-50 flex justify-between"
//                       >
//                         {lang}
//                         {lang === selectedLang && "✓"}
//                       </button>
//                     ))}
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//       </div>
//     </nav>
//   );
// };

// export default AuthNavbar;
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./AuthNavbar.module.css";

const LANGUAGES = ["English", "Hindi", "Telugu"];

export default function AuthNavbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [langOpen, setLangOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState("English");

  const isSignIn = location.pathname === "/sign-in";
  const isRegister = location.pathname === "/register";

  return (
    <nav className={styles.nav}>
      {/* Logo */}
      <a href="/" className={styles.logo}>
        <img src="https://fplogoimages.withfloats.com/actual/69307aedfe3cec81a85953aa.png" alt="Avexa" className={styles.logoImg} />
      </a>

      {/* Right side */}
      <div className={styles.navRight}>
        {isRegister && (
          <span className={styles.navHint}>Already have an account?</span>
        )}
        {isSignIn && (
          <span className={styles.navHint}>Don't have an account?</span>
        )}

        <button
          className={styles.navCta}
          onClick={() => navigate(isSignIn ? "/register" : "/sign-in")}
        >
          {isSignIn ? "Sign up" : "Sign in"}
        </button>

        <div className={styles.navDivider} />

        {/* Language selector */}
        <div className={styles.langWrap}>
          <button
            className={styles.langBtn}
            onClick={() => setLangOpen((v) => !v)}
            aria-haspopup="listbox"
            aria-expanded={langOpen}
          >
            <span className={styles.langGlobe}>🌐</span>
            <span className={styles.langLabel}>{selectedLang}</span>
            <svg
              className={`${styles.langChevron} ${langOpen ? styles.langChevronOpen : ""}`}
              width="12" height="12" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" strokeWidth="2"
            >
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {langOpen && (
            <>
              <div className={styles.langOverlay} onClick={() => setLangOpen(false)} />
              <div className={styles.langDropdown} role="listbox">
                {LANGUAGES.map((lang) => (
                  <button
                    key={lang}
                    role="option"
                    aria-selected={lang === selectedLang}
                    className={`${styles.langOption} ${lang === selectedLang ? styles.langOptionActive : ""}`}
                    onClick={() => { setSelectedLang(lang); setLangOpen(false); }}
                  >
                    {lang}
                    {lang === selectedLang && <span className={styles.langCheck}>✓</span>}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}